import { render, staticRenderFns } from "./AdminPuzzleRowForm.vue?vue&type=template&id=4e872b33"
import script from "./AdminPuzzleRowForm.vue?vue&type=script&lang=js"
export * from "./AdminPuzzleRowForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports